<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';
import {
  mountAceleresFunilFrame,
  parkAceleresFunilFrame,
  refreshAceleresFunilFrame,
} from 'dashboard/helper/sidebarPagePreload';

const iframeKey = ref(0);
const frameContainerRef = ref(null);
const usesManagedFrame = ref(typeof window !== 'undefined');
const isLoading = ref(true);
const hasError = ref(false);
const pageTitle = 'Carteirização';
const pageDescription = 'Funil aberto dentro do painel principal.';
const reloadLabel = 'Recarregar';
const loadingLabel = 'Carregando funil...';
const errorTitle = 'Nao foi possivel abrir o funil';
const errorDescription =
  'Tente recarregar a tela. Se o problema persistir, valide se /funil esta sendo servido pelo ambiente.';

const reloadFrame = () => {
  iframeKey.value += 1;
  isLoading.value = true;
  hasError.value = false;

  if (usesManagedFrame.value) {
    const frame = frameContainerRef.value?.querySelector('iframe');
    if (frame) {
      refreshAceleresFunilFrame(frame);
    }
  }
};

const onLoad = () => {
  isLoading.value = false;
};

const onError = () => {
  isLoading.value = false;
  hasError.value = true;
};

onMounted(() => {
  usesManagedFrame.value = mountAceleresFunilFrame(frameContainerRef.value, {
    onLoad,
    onError,
  });
});

onBeforeUnmount(() => {
  if (usesManagedFrame.value) {
    parkAceleresFunilFrame();
  }
});
</script>

<template>
  <section class="flex flex-col flex-1 min-w-0 min-h-0 bg-n-background">
    <header
      class="flex items-start justify-between flex-shrink-0 gap-2 px-4 py-3 border-b border-n-weak bg-n-background sm:items-center sm:gap-3 sm:px-6 sm:py-4"
    >
      <div class="min-w-0">
        <h1 class="m-0 text-lg font-semibold text-n-slate-12 sm:text-xl">
          {{ pageTitle }}
        </h1>
        <p class="m-0 mt-1 text-sm text-n-slate-11">{{ pageDescription }}</p>
      </div>

      <div
        class="acl-mobile-account-menu-host flex flex-shrink-0 items-center gap-2"
      >
        <button
          type="button"
          class="inline-flex flex-shrink-0 items-center gap-2 px-2.5 py-2 text-sm font-medium transition-colors border rounded-lg border-n-weak text-n-slate-12 bg-n-surface-1 hover:bg-n-alpha-2 sm:px-3"
          @click="reloadFrame"
        >
          <span class="i-lucide-refresh-cw size-4" />
          <span class="sr-only sm:not-sr-only">{{ reloadLabel }}</span>
        </button>
      </div>
    </header>

    <div class="relative flex-1 min-h-0 bg-white">
      <div
        v-if="isLoading"
        class="absolute inset-0 z-10 flex items-center justify-center bg-n-background"
      >
        <div class="flex items-center gap-3 text-sm text-n-slate-11">
          <span class="i-lucide-loader-circle size-5 animate-spin" />
          {{ loadingLabel }}
        </div>
      </div>

      <div
        v-if="hasError"
        class="absolute inset-0 z-20 flex items-center justify-center px-6 bg-n-background"
      >
        <div class="max-w-md text-center">
          <h2 class="m-0 text-base font-semibold text-n-slate-12">
            {{ errorTitle }}
          </h2>
          <p class="m-0 mt-2 text-sm text-n-slate-11">{{ errorDescription }}</p>
        </div>
      </div>

      <div ref="frameContainerRef" class="w-full h-full">
        <iframe
          v-if="!usesManagedFrame"
          :key="iframeKey"
          src="/funil"
          :title="pageTitle"
          class="block w-full h-full border-0"
          @load="onLoad"
          @error="onError"
        />
      </div>
    </div>
  </section>
</template>
